import "./polyfills";

import { CollapseVanilla } from "@busbud/horizon";

import { initializeButtonLinks } from "@app/components/button-link/button-link-script";
import { setupWhitelabelTheme } from "@app/entries/setups/whitelabel-theme";
import { setBusbudEnv } from "@app/helpers/isomorphic-busbud-env";
import { HeaderDrawer } from "@app/modules/core/vanilla/header-drawer";
import { HeaderDropdowns } from "@app/modules/core/vanilla/header-dropdowns";
import TrackVisibleElements from "@app/modules/core/vanilla/track-elements";
import TrackTranslate from "@app/modules/core/vanilla/track-translate";
import UI from "@app/modules/core/vanilla/ui";

import { CountdownTimer } from "./countdown-timer";

setBusbudEnv(window.BB.config.env);

(function preloadTheme() {
  void setupWhitelabelTheme();
})();

window.addEventListener("load", () => {
  UI.init(window);
  TrackVisibleElements.init();
  new CountdownTimer().start();
  HeaderDropdowns();
  new HeaderDrawer();
  initializeButtonLinks();
  TrackTranslate.init();
  new CollapseVanilla();
});
